import './Tag.scss';
import clsx from 'clsx';
import React, { memo, PropsWithChildren } from 'react';

type Props = PropsWithChildren<{
  status: 'disabled' | 'active' | 'success' | 'error';
}>;

export const Tag = memo(({ status, children }: Props) => (
  <span className={clsx({
    'bp-tag': true,
    [`bp-tag--${status}`]: true,
  })}
  >
    {children}
  </span>
));
